
import {get_color} from "@/pages/mindmap/CarNodes/BasicCardNode.tsx";
import {formatCompactNumber, formatPercentage} from "@/utils/format.ts";
import {TreeNode} from "@/types";

interface SegmentNodeData {
    node: TreeNode
}

export const SegmentNode = ({node}: SegmentNodeData) => {
    const datas = node.metrics_map || {}


    const get_child_gap = (rank:string) => {
        const child = node.children?.find(c => c.id.endsWith(`-${rank}`))
        const datas = child?.metrics_map || {}

        return <div>
            <span>Seg {rank.toUpperCase()}: &nbsp;</span>
            {(datas["ims_amt_mtd_gap"]?.value ?? 0) < 0 ?
                <span style={get_color("ims_amt_mtd_gap", datas)}>
                {formatCompactNumber((datas["ims_amt_mtd_gap"]?.value ?? 0))}
            </span>:
                <>--</>
            }
        </div>
    }

    return <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '2px 12px',
        marginBottom: '2px',
        color: 'rgb(71, 85, 105)'
    }}>
        <div style={{fontWeight: 700, color: 'rgb(30, 41, 59)'}}>IMS Contribution (MTD)</div>
        <div style={{fontWeight: 700, color: 'rgb(30, 41, 59)'}}>IMS Gap (MTD)</div>

        <div>
            <span>Seg A: </span>
            <span style={get_color("seg_a_amt_pct", datas)}>
                {formatPercentage(datas["seg_a_amt_pct"]?.value)}
            </span>
        </div>
        {get_child_gap("a")}

        <div>
            <span>Seg B: </span>
            <span style={get_color("seg_b_amt_pct", datas)}>
                {formatPercentage(datas["seg_b_amt_pct"]?.value)}
            </span>
        </div>
        {get_child_gap("b")}

        <div>
            <span>Seg C: </span>
            <span style={get_color("seg_c_amt_pct", datas)}>
                {formatPercentage(datas["seg_c_amt_pct"]?.value)}
            </span>
        </div>
        {get_child_gap("c")}

    </div>
}